import React from 'react';

export const CreateChannerForm = ({ handleOnChange }) => {
	return (
		<div className="reach_form offset_mod">
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="channelName">channelName</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="text"
							id="channelName"
							placeholder="Channel name*"
							required
							name="channelName"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="subtitle">subtitle</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="text"
							id="subtitle"
							placeholder="Subtitle"
							name="subtitle"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="email">email</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="email"
							id="email"
							placeholder="Email*"
							required
							name="accountEmail"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="link">link</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<input
							className="form_field default_mod"
							type="text"
							id="link"
							placeholder="Link"
							name="link"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
			<div className="reach_form_controller full_mod">
				<dl className="form_cell form_cell_v1_mod">
					<dt className="form_cell_title form_v1_mod hline_hide_mod">
						<label htmlFor="description">description</label>
					</dt>
					<dd className="form_field_wrap form_v1_mod hline_hide_mod">
						<textarea
							className="form_field textarea_mod_1 default_mod"
							id="description"
							placeholder="Description"
							name="description"
							onChange={handleOnChange}
						/>
					</dd>
				</dl>
			</div>
		</div>
	);
}
export default CreateChannerForm;